import React, { forwardRef, useState } from 'react'
import styled from 'styled-components'
import { TextInput, TextInputProps } from './TextInput'
import { EyeOpenIcon, EyeClosedIcon } from '../../icons/EyeIcons'

export type PasswordInputProps = Omit<TextInputProps, 'type' | '$endAdornment'>

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  (props, ref) => {
    const [visible, setVisible] = useState(false)
    return (
      <TextInput
        {...props}
        ref={ref}
        type={visible ? 'text' : 'password'}
        $endAdornment={
          <ToggleButton
            type="button"
            onClick={() => setVisible((v) => !v)}
            aria-label={visible ? 'הסתר סיסמה' : 'הצג סיסמה'}
          >
            {visible ? <EyeClosedIcon /> : <EyeOpenIcon />}
          </ToggleButton>
        }
      />
    )
  },
)
PasswordInput.displayName = 'PasswordInput'

const ToggleButton = styled.button`
  position: absolute;
  left: 0.625rem;
  width: 1.75rem;
  height: 1.75rem;
  border: 0;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.ink3};
  border-radius: ${({ theme }) => theme.radii.sm};
  transition: color ${({ theme }) => theme.motion.fast},
    background ${({ theme }) => theme.motion.fast};

  &:hover {
    color: ${({ theme }) => theme.colors.ink};
    background: ${({ theme }) => theme.colors.line2};
  }
`

export default PasswordInput
